"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYERS = exports.NUM_ROWS = exports.NUM_COLUMNS = void 0;
exports.NUM_COLUMNS = 7;
exports.NUM_ROWS = 6;
exports.PLAYERS = ['P1', 'P2'];
